var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_c('img',{attrs:{"src":require("../../assets//successs.svg"),"alt":""}}),_c('br'),_vm._v("\n  提交成功\n")])
}]

export { render, staticRenderFns }